import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Locations from '@/components/Locations'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      meta: {
        title: 'Home | Advantage Truck Group'
      }
    },
    {
      path: '/locations/:loc',
      name: 'Locations',
      component: Locations,
      meta: {
        title: 'Locations | Advantage Truck Group'
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js